import { Material } from '../../products/product-list/material.model';
import { Category } from './category.model';

export class CategoryProduct {
    category?: Category;
    orderNumber?: number;
    product?: Material;
}
